

import React, { useState, useEffect } from "react";
// import Modal from "./Modal";
import TooltipButton from "../Button/TooltipButton";
import OrangeGradientButton from "../Button/OrangeGradientButton";
import api from "../../api/baseUrl";

import ExportExcelButton from "../Button/ExportExcelButton";

import "./Table.css"
import Invoice from "../Invoice/Invoice";
import PrimaryButton from "../Button/primaryButton/PrimaryButton";

import Snackbar from "../SnackBar/SnackBar";
import edidIcon from "../../icons/edit.svg";
import viewIcon from "../../icons/Property 1=broken (5).svg";
import deleteIcon from "../../icons/trash.svg";
import Dropdown from "./DropDown/DropDown";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";
import NoData from "../NoData/NoData";

const Modal = ({ isOpen, onClose, children, fullscreen = false }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal ${fullscreen ? 'fullscreen' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>✕</button>
        {children}
      </div>
    </div>
  );
};


const Table = ({ title, orders = [], visitors = [], sellers = [], products = [], refreshDataProducts, refreshDataSeller, refreshDataInvoices, showExportButton = true, showAddSellerButton = false, // 🔸 مقدار پیش‌فرض false

}) => {
  const [showModal, setShowModal] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [invoiceDetailsProduct, setInvoiceDetailsProduct] = useState(null);
  const [paymentError, setPaymentError] = useState("");

  const [shouldGroup, setShouldGroup] = useState(false); // پیشفرض با جداکننده

  const [snackbar, setSnackbar] = useState({ message: "", type: "info" });
  const [loading, setLoading] = useState(false);




  const [getDataAllInvoice, setGetDataAllInvoice] = useState("");


  const [currentPage, setCurrentPage] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);
  const [pageProducts, setPageProducts] = useState([]);

  const [invoiceCount, setInvoiceCount] = useState([]);


  
      const [invoiceCountWeek, setInvoiceCountWeek] = useState(""); // مقداری که با Enter تأیید شده
    const [invoiceCountToday, setInvoiceCountToday] = useState(""); // مقداری که با Enter تأیید شده

  const [searchQuery, setSearchQuery] = useState(""); // مقدار تایپ‌شده
  const [appliedSearch, setAppliedSearch] = useState(""); // مقداری که با Enter تأیید شده
  const [countAllData, setCountAllData] = useState(""); // مقداری که با Enter تأیید شده

  const fetchPage = async (page = 1, search = "") => {
    let timer;

    try {
      // اگر درخواست طول بکشد، بعد 200ms لودینگ نمایش داده شود
      timer = setTimeout(() => setLoading(true), 200);

      // فراخوانی تابع refreshDataInvoices که به سرور GET یا POST میزند
      const data = await refreshDataInvoices(page, search);

      if (!data) return;

      // داده‌های صفحه فعلی
      setPageProducts(data.messages || []);

setInvoiceCount(data.invoiceCount)
      setCountAllData(data.allData)
      setInvoiceCountWeek(data.invoiceCountWeek)
      setInvoiceCountToday(data.invoiceCountToday)
      // تعداد کل صفحات
      setPagesCount(data.pagesCount || 1);

      // اگر صفحه فعلی بیشتر از تعداد صفحات شد، آن را تصحیح کن
      if (page > (data.pagesCount || 1)) {
        setCurrentPage(data.pagesCount || 1);
      }
    } catch (err) {
      console.error("Error fetching page:", err);
      setPageProducts([]);
      setPagesCount(1);
    } finally {
      clearTimeout(timer);
      setLoading(false);
    }
  };



  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setCurrentPage(1); // حتما به صفحه 1 برگرد
      setAppliedSearch(searchQuery.trim());
    }
  };
  useEffect(() => {
    fetchPage(currentPage, appliedSearch);
  }, [currentPage, appliedSearch]);



  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagesCount) return;
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const inputs = document.querySelectorAll(".no-negative");

    inputs.forEach((input) => {
      input.addEventListener("input", (e) => {
        if (e.target.value.startsWith("-")) {
          e.target.value = e.target.value.replace("-", "");
        }
      });
    });

    // cleanup برای جلوگیری از memory leak
    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("input", () => { });
      });
    };
  }, []); // ← این پرانتز بسته و درستش همینجوریه


  const [newOrder, setNewOrder] = useState({
    amount_toman: "",
    product_id: "",
    marketer_id: "",
    seller_id: "",
    invoice_desc: "",
    paymentTypes: [],
    paymentNotes: { cash: "", cheque: "", other: "" },
    products: []  // ← دیگه آیتم خالی پیشفرض نداره

  });






  const handleAddOrder = async (e) => {
    e.preventDefault();

    const payment_cash = newOrder.paymentTypes.includes("cash") ? "1" : "0";
    const payment_cheque = newOrder.paymentTypes.includes("cheque") ? "1" : "0";
    const payment_other = newOrder.paymentTypes.includes("other") ? "1" : "0";

    const payment_cash_desc = newOrder.paymentNotes.cash || "پرداخت نقدی";
    const payment_cheque_desc = newOrder.paymentNotes.cheque || "پرداخت چکی";
    const payment_other_desc = newOrder.paymentNotes.other || "نسیه پرداخت‌ها";

    const payment_cash_price = newOrder.paymentAmounts.cash || "0";
    const payment_cheque_price = newOrder.paymentAmounts.cheque || "0";
    const payment_other_price = newOrder.paymentAmounts.other || "0";

    const products = newOrder.products
      .filter(p => p.product_id) // فقط محصولاتی که انتخاب شدن
      .map((p) => ({
        product_id: p.product_id.toString(),
        product_quantity: p.product_quantity,
        selling_price: p.selling_price.toString()
      }));

    // تاریخ میلادی امروز
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const hour = String(today.getHours()).padStart(2, '0');
    const minute = String(today.getMinutes()).padStart(2, '0');
    const second = String(today.getSeconds()).padStart(2, '0');

    const date_created = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

    const body = {
      action: "add",
      date_created: date_created, // تاریخ میلادی امروز
      seller_id: newOrder.seller_id,
      marketer_id: newOrder.marketer_id,
      payment_cash,
      payment_cash_desc,
      payment_cash_price,
      payment_cheque,
      payment_cheque_desc,
      payment_cheque_price,
      payment_other,
      payment_other_desc,
      payment_other_price,
      invoice_desc: newOrder.invoice_desc,
      products
    };

    try {
      const result = await api.post("/crud-invoices", body);

      setShowModal(false);

      if (result.data.accepted) {

        fetchPage(currentPage, appliedSearch);
        setSnackbar({
          title: "موفقیت",
          description: `فاکتور با موفقیت اضافه شد!`,
          type: "success"
        });
      }

      setNewOrder({
        marketer_id: "",
        seller_id: "",
        invoice_desc: "",
        paymentTypes: [],
        paymentNotes: { cash: "", cheque: "", other: "" },
        paymentAmounts: { cash: "", cheque: "", other: "" },
        paymentAmountsDisplay: { cash: "", cheque: "", other: "" },
        products: [{ product_id: "", product_quantity: 1, selling_price: "" }]
      });
    } catch (error) {
      console.error("خطا در ارسال فاکتور:", error);
      alert("ارسال فاکتور موفق نبود");
    }
  };
  const handleDelete = async (id) => {
    const invoiceToDelete = orders.find(s => s.invoice_id === id); // توجه کنید از invoice_id استفاده کنید
    try {
      const result = await api.post("/crud-invoices", { action: "delete", invoice_id: id });
      if (result.data.accepted) {

        fetchPage(currentPage, appliedSearch);

        setSnackbar({
          title: "موفقیت",
          description: `فاکتور "${invoiceToDelete.invoice_number}" با موفقیت حذف شد!`,
          type: "success"
        });
      } else {
        setSnackbar({
          title: "ناموفق",
          description: `حذف فاکتور "${invoiceToDelete.invoice_number}" ناموفق بود!`,
          type: "error"
        });
      }
    } catch (error) {
      console.error("خطا در حذف:", error);
      setSnackbar({
        title: "خطا",
        description: `حذف فاکتور "${invoiceToDelete.invoice_number}" با خطا مواجه شد!`,
        type: "error"
      });
    }
  };



  const handleSeeDetails = async (id) => {
    try {
      const result = await api.post("/view-invoice", { invoice_id: id });
      if (result.data.accepted && result.data.message) {
        setInvoiceDetails(result.data.message.invoice_data);

        setShowInvoiceModal(true);
        setInvoiceDetailsProduct(result.data.message.invoice_products)
      } else {
        alert("اطلاعات فاکتور یافت نشد");
      }
    } catch (error) {
      console.error("خطا در دریافت فاکتور:", error);
      alert("خطا در دریافت اطلاعات فاکتور");
    }
  };

  const handleGetDataAllInvoice = async () => {
    try {
      const result = await api.post("/crud-invoices", { action: "get", invoice_id: 2026140507 });

      if (result.data.accepted && result.data.message) {
        setGetDataAllInvoice(result.data.message);
        return result.data.message;
      } else {
        alert("اطلاعات فاکتور یافت نشد");
        return [];
      }
    } catch (error) {
      console.error("خطا در دریافت فاکتور:", error);
      alert("خطا در دریافت اطلاعات فاکتور");
      return [];
    }
  };


  {/* مجموع کل محصولات */ }
  const totalProductsAmount = newOrder.products
    .filter(p => p.product_id)
    .reduce((total, p) => total + (p.product_quantity * Number(p.selling_price)), 0);

  // جمع پرداخت شده
  const totalPaidAmount = Object.values(newOrder.paymentAmounts || {}).reduce(
    (sum, val) => sum + Number(val || 0),
    0
  );

  // مانده قابل پرداخت
  const remainingAmount = totalProductsAmount - totalPaidAmount;



  useEffect(() => {
    refreshDataProducts(); // فقط یکبار هنگام mount اجرا میشه
    refreshDataSeller();
  }, []); // dependency array خالی => فقط یکبار


  return (
    <div className="">


      <div className="card-header">
        <h2 className="card-title">{title}</h2>

        <div className="header-actions">
          <div className="search-container">
            <input
              type="text"
              className="search-input"
              placeholder="جستجو بر اساس نام یا کد ملی..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleSearchKeyDown}
            />
          </div>

          <div className="button-group-header-card">
            <ExportExcelButton fetchData={handleGetDataAllInvoice} />
            <OrangeGradientButton onClick={() => setShowModal(true)}>
              افزودن فاکتور
            </OrangeGradientButton>

          </div>

        </div>
      </div>















      <div className="table-container">

            <div class="stats-container">
        
        <div class="cards-grid">
            <div class="stat-card card-all-invoices">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">همه فاکتورها</p>
                        <p class="card-value"> {Number(invoiceCount || 0).toLocaleString('fa-IR')}</p>
                        
                    
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-file-invoice card-icon"></i>
                    </div>
                </div>
            </div>

            <div class="stat-card card-total-items">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">تعداد آیتم ها</p>
                        <p class="card-value">  {Number(countAllData || 0).toLocaleString('fa-IR')}</p>
                      
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-cube card-icon"></i>
                    </div>
                </div>
            </div>

            <div class="stat-card card-today-invoices">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">فاکتورهای امروز</p>
                        <p class="card-value">{Number(invoiceCountToday || 0).toLocaleString('fa-IR')}
</p>
                    
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-calendar-day card-icon"></i>
                    </div>
                </div>
            </div>

            <div class="stat-card card-week-invoices">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">فاکتورهای هفته</p>
                        <p class="card-value">{Number(invoiceCountWeek || 0).toLocaleString('fa-IR')}</p>
                
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-calendar-week card-icon"></i>
                    </div>
                </div>
            </div>
        </div>

 
    </div>










        {loading ? (
          <SkeletonLoader rows={20} />
        ) : products.length > 0 ? (
          <>
            <table>
              <thead>
                <tr>
                  <th>شناسه فاکتور</th>
                  <th>شماره فاکتور</th>
                  <th>نام محصول</th>
                  <th>تعداد فاکتور</th>
                  <th>مبلغ فروش (تومان)</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {pageProducts.map((order) => (
                  <tr key={order.invoice_id}>
                    <td>{order.invoice_id}</td>
                    <td>{order.invoice_number}</td>
                    <td>{order.product_name}</td>
                    <td>{order.product_quantity}</td>
                    <td>{Number(order.selling_price).toLocaleString('fa-IR')}</td>
                    <td >
                      <div className="button-group">
                        <TooltipButton
                          icon={viewIcon}
                          alt="فاکتور"
                          tooltipText="فاکتور"
                          onClick={() => handleSeeDetails(order.invoice_id)}
                          className="tooltip-button"
                        />
                        <TooltipButton
                          icon={deleteIcon}
                          alt="حذف"
                          tooltipText="حذف"
                          onClick={() => {
                            setDeleteItemId(order.invoice_id);
                            setDeleteModalOpen(true);
                          }}
                          className="delete-btn tooltip-button  margin-btn"
                        />


                      </div>


                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination">
              {/* قبلی */}
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                قبلی
              </button>

              {/* دکمه‌های صفحه با ... */}
              {Array.from({ length: pagesCount }, (_, i) => i + 1)
                .filter((page) => {
                  // همیشه اول، آخر و صفحات نزدیک currentPage را نشان بده
                  return (
                    page === 1 ||
                    page === pagesCount ||
                    (page >= currentPage - 1 && page <= currentPage + 1)
                  );
                })
                .map((page, idx, arr) => {
                  const prev = arr[idx - 1];

                  // اضافه کردن ... اگر فاصله زیاد باشد
                  if (prev && page - prev > 1) {
                    return (
                      <React.Fragment key={page}>
                        <span style={{ padding: "0 5px" }}>...</span>
                        <button
                          onClick={() => handlePageChange(page)}
                          className={currentPage === page ? "active" : ""}
                        >
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  }

                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={currentPage === page ? "active" : ""}
                    >
                      {page}
                    </button>
                  );
                })}

              {/* بعدی */}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagesCount}>
                بعدی
              </button>

<select className="order-count-select" value="placeholder">
  <option value="placeholder" disabled>
    تعداد: {pageProducts.length}
  </option>
</select>




            </div>
          </>
        ) : (
          <NoData message="هیچ فاکتوری یافت نشد" />
        )}





      </div>



      {/* مودال نمایش اطلاعات فاکتور */}
      {showInvoiceModal && invoiceDetails && invoiceDetailsProduct && (
        <Modal
          isOpen={showInvoiceModal}
          onClose={() => setShowInvoiceModal(false)}
          fullscreen={true}
        >
          <Invoice
            invoiceDetails={invoiceDetails}
            invoiceDetailsProduct={invoiceDetailsProduct}
          />
        </Modal>

      )}

      {/* مودال افزودن فاکتور */}
      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <h3 className="modal-title">افزودن فاکتور جدید</h3>
        <form className="modal-form" onSubmit={handleAddOrder}>

          <div className="wrapper-column">
            {/* <Dropdown
              type="single"
              value={newOrder.marketer_id}
              onChange={(id) => setNewOrder({ ...newOrder, marketer_id: id })}
              items={visitors}
              placeholder="انتخاب ویزیتور"
              itemType="marketer"

            /> */}


            {/* فروشنده */}
            <Dropdown
              type="single"
              value={newOrder.seller_id}
              onChange={(id) => setNewOrder({ ...newOrder, seller_id: id })}
              items={sellers || []}   // ✅ فقط messages
              placeholder="انتخاب فروشنده"
              itemType="seller"
            />


          </div>


          <h3 className="modal-title">انتخاب محصولات</h3>

          {/* انتخاب محصول */}
          <div className="form__input-group">

            <Dropdown
              type="single"
              value={newOrder.product_id}
              onChange={(id) => {
                const selectedProduct = products.find((p) => p.id.toString() === id);
                setNewOrder((prev) => ({
                  ...prev,
                  product_id: id,
                  amount_toman: selectedProduct?.price || "",
                  amount_toman_display: selectedProduct
                    ? Number(selectedProduct.price).toLocaleString("fa-IR")
                    : "",
                }));
              }}
              items={products.map(p => ({
                id: p.id.toString(),
                name: `${p.name} ${p.category} ${p.brand} - ${Number(p.price).toLocaleString("fa-IR")} تومان`
              }))}
              placeholder="انتخاب محصول"
            />


          </div>

          {/* تعداد محصول */}
          <div className="form__input-group">
            <input
              type="number"
              name="product_quantity"
              placeholder=" "
              value={newOrder.product_quantity || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  setNewOrder({ ...newOrder, product_quantity: value });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // نذاره منفی یا e وارد شه
                }
              }}
              className="form__input no-negative"
            />

            <label className="form__input-label">تعداد محصول (قوطی)</label>
          </div>

          {/* مبلغ فروش */}
          <div className="form__input-group">
            <input
              type="text"
              name="amount_toman"
              placeholder=" "
              value={newOrder.amount_toman_display || ""}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, "");
                setNewOrder((prev) => ({
                  ...prev,
                  amount_toman: numericValue,
                  amount_toman_display: numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                }));
              }}
              className="form__input"
            />
            <label className="form__input-label">مبلغ فروش (تومان)</label>
          </div>

          {/* دکمه افزودن محصول */}

          <PrimaryButton title={"+ افزودن محصول"} onClick={() => {
            if (newOrder.product_id && newOrder.product_quantity && newOrder.amount_toman) {
              setNewOrder((prev) => ({
                ...prev,
                products: [
                  ...(prev.products || []),
                  {
                    product_id: prev.product_id,
                    product_quantity: parseInt(prev.product_quantity, 10),
                    selling_price: prev.amount_toman.toString(),
                  },
                ],
                // product_id: "",
                // product_quantity: "",
                // amount_toman: "",
              }));
            } else {
              alert("لطفا محصول، تعداد و مبلغ را وارد کنید");
            }
          }} />

          {/* محصولات انتخاب‌شده */}
          {newOrder.products && newOrder.products.length > 0 && (
            <div

            >
              <h3
                className="modal-title"
                style={{
                  marginBottom: '1rem',
                }}
              >
                محصولات انتخاب شده
              </h3>

              <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {newOrder.products
                  .filter(p => p.product_id)
                  .map((p, i) => {
                    const prodName = products.find(pr => pr.id.toString() === p.product_id)?.name;

                    const prodBrand = products.find(pr => pr.id.toString() === p.product_id)?.brand;

                    const prodCategory = products.find(pr => pr.id.toString() === p.product_id)?.category;


                    if (!prodName) return null;
                    return (
                      <li
                        key={i}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          backgroundColor: '#fff',
                          padding: '0.75rem 1rem',
                          marginBottom: '0.75rem',
                          borderRadius: '8px',
                          border: '1px solid #e5e5e5',
                          transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
                        }}
                      >
                        {/* <span style={{ fontSize: '16px', color: '#555', lineHeight: 1.6 }}>
                          {prodName} {prodCategory} {prodBrand}  — تعداد: {new Intl.NumberFormat('fa-IR').format(p.product_quantity)} — قیمت:{' '}
                          {Number(p.selling_price).toLocaleString('fa-IR')}
                        </span> */}
                        <span style={{ fontSize: '16px', color: '#555', lineHeight: 1.6 }}>
                          {prodName} {prodCategory} {prodBrand} — تعداد: {new Intl.NumberFormat('fa-IR').format(p.product_quantity)} — قیمت واحد: {Number(p.selling_price).toLocaleString('fa-IR')} — قیمت کل: {(p.product_quantity * Number(p.selling_price)).toLocaleString('fa-IR')}
                        </span>

                        <TooltipButton
                          icon={deleteIcon}
                          alt="حذف"
                          tooltipText="حذف"
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            setNewOrder(prev => ({
                              ...prev,
                              products: prev.products.filter((_, idx) => idx !== i),
                            }));
                          }}
                          className="delete-btn margin-btn" />
                      </li>
                    );
                  })}
              </ul>
            </div>
          )}

          {/* جمع کل محصولات */}
          <div style={{ marginTop: '1rem', fontWeight: 'bold', fontSize: '16px', color: '#333' }}>
            مجموع کل:{" "}
            {newOrder.products
              .filter(p => p.product_id)
              .reduce((total, p) => total + (p.product_quantity * Number(p.selling_price)), 0)
              .toLocaleString('fa-IR')} تومان
          </div>
          {/* بخش تسویه */}
          <div className="payment-section">
            <h3 className="modal-title">نحوه تسویه :  </h3>
            <div className="remaining-amount" style={{ marginTop: '1rem', fontWeight: 'bold', color: '#333' }}>
              مانده قابل پرداخت: {remainingAmount.toLocaleString('fa-IR')} تومان
            </div>

            {["cash", "cheque", "other"].map((type) => {
              const labels = { cash: "نقدی", cheque: "چکی", other: "نسیه" };
              return (
                <div key={type} className="payment-type">
                  <label className="check-label">
                    <input
                      type="checkbox"
                      checked={newOrder.paymentTypes.includes(type)}
                      onChange={(e) => {
                        const checked = e.target.checkd;
                        setNewOrder((prev) => ({
                          ...prev,
                          paymentTypes: checked
                            ? [...prev.paymentTypes, type]
                            : prev.paymentTypes.filter((p) => p !== type),
                          paymentNotes: { ...prev.paymentNotes, [type]: "" },
                          paymentAmounts: { ...prev.paymentAmounts, [type]: "" },
                          paymentAmountsDisplay: { ...prev.paymentAmountsDisplay, [type]: "" },
                        }));
                      }}
                    />
                    <span>{labels[type]}</span>
                  </label>

                  {newOrder.paymentTypes.includes(type) && (
                    <div className="payment-details">
                      <input
                        type="text"
                        className={`payment-${type}-price form__input`}
                        placeholder="مبلغ"
                        value={newOrder.paymentAmountsDisplay?.[type] || ""}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/\D/g, "");
                          const newPaymentAmounts = { ...newOrder.paymentAmounts, [type]: numericValue };
                          const totalPaid = Object.values(newPaymentAmounts).reduce((sum, val) => sum + Number(val || 0), 0);

                          if (totalPaid > totalProductsAmount) {
                            setPaymentError("مجموع پرداخت‌ها نمی‌تواند بیشتر از کل مبلغ باشد!");
                          } else {
                            setPaymentError("");
                          }

                          setNewOrder((prev) => ({
                            ...prev,
                            paymentAmounts: newPaymentAmounts,
                            paymentAmountsDisplay: {
                              ...prev.paymentAmountsDisplay,
                              [type]: numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                            },
                          }));
                        }}

                      />

                      {paymentError && (
                        <div style={{ color: "red", marginTop: "0.5rem", fontWeight: "bold" }}>
                          {paymentError}
                        </div>
                      )}

                      <textarea
                        placeholder={`توضیح پرداخت ${labels[type]}`}
                        value={newOrder.paymentNotes[type]}
                        onChange={(e) =>
                          setNewOrder((prev) => ({
                            ...prev,
                            paymentNotes: { ...prev.paymentNotes, [type]: e.target.value },
                          }))
                        }
                        rows={3}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* توضیح فاکتور */}
          <div className="form__input-group invoice-explanation">
            <input
              type="text"
              name="invoice_desc"
              placeholder=" "
              value={newOrder.invoice_desc}
              required
              onChange={(e) =>
                setNewOrder({ ...newOrder, invoice_desc: e.target.value })

              }
              className="form__input"
            />
            <label className="form__input-label">توضیح فاکتور</label>
          </div>

          <PrimaryButton type="submit" title="ذخیره فاکتور" loading={loading} disabled={
            !!paymentError ||
            remainingAmount !== 0 ||
            !(newOrder.products?.length > 0)

          }
          />

        </form>

      </Modal>

      <Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <h3 className="delete-modal-title">آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟</h3>
        <div className="modal-buttons">
          <button className="btn cancel-btn" onClick={() => setDeleteModalOpen(false)}>انصراف</button>
          <button className="btn confirm-btn" onClick={() => { handleDelete(deleteItemId); setDeleteModalOpen(false); }}>تایید</button>
        </div>
      </Modal>

      <Snackbar
        title={snackbar.title}
        description={snackbar.description}
        type={snackbar.type}
        duration={2000}
        onClose={() => setSnackbar({ title: "", description: "", type: "info" })}
      />
    </div>


  );
};

export default Table;
